const fa = {
    9000001: "جایزه کریسمس 2023",
    9000002: "مسابقات فیوچرز سوپراکس",
    9000003: "30000 USDT در جایزه مسابقه برنده شوید!",
    9000004: "تعداد شرکت کنندگان",
    9000005: "استخر جایزه باز شد (USDT)",
    9000006: "واجد شرایط رتبه بندی حجم معاملات",
    9000007: " منرخ سودآوری رده‌بندی مسابقه",
    9000008: "رقابت مقدماتی رتبه بندی سود ",
    9000009: `رویداد  حجم معاملات: بالاترین جایزه <span style="color: #ffc72b;">20,000</span> USDT را باز کنید.`,
    9000010: "با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 20000 USDT بزرگتر باز می شود. ",
    9000011: "مقدار جایزه‌ها ",
    9000012: "به روز رسانی روزانه در ساعت 10:00 UTC.",
    9000013: "تخمین پاداش",
    9000014: "مبلغ معاملات آتی تجمعی در طول دوره",
    9000015: "قوانین پاداش",
    9000016: "با توجه به تعداد شرکت کنندگان، هرچه تعداد شرکت کنندگان بیشتر باشد، استخر جایزه تا سقف 20000 USDT بزرگتر باز می شود. ",
    9000017: "مقدار جایزه‌ها (USDT)",
    9000018: "نرخ سودآوری فعالیت‌ها بر اساس رتبه‌بندی",
    9000019: "ثبت‌نام",
    9000020: "رتبه بندی سود فعالیت",
    9000021: "به پایان رسید",
    9000022: `مسابقه رتبه بندی نرخ سود - از پاداش <span style="color: #ffc72b;">{moneyPond}</span> USDT لذت ببرید`,
    9000023: `رقابت رتبه بندی سود - از پاداش <span style="color: #ffc72b;">{moneyPond}</span> USDT لذت ببرید`,
    9000024: "نرخ سودآوری کل فیوچر",
    9000025: "سود انباشته",
    9000026: "شروع نشده است",
    9000027: "به 50 شرکت کننده برتر در مسابقه رتبه بندی سود جوایزی اهدا خواهد شد. برای جزئیات، لطفاً برای دریافت جوایز به قوانین پاداش رتبه بندی مراجعه کنید. ",
    9000028: "به 50 شرکت کننده برتر از نظر سودآوری پاداش داده می شود، لطفاً برای دریافت پاداش به قوانین پاداش رتبه بندی معاملات مراجعه کنید. ",
    9000029: "رتبه بندی حجم تراکنش فعالیت",
    9000030: "ثبتنام موفقیتآمیز",
    9000031: "برنامه را دانلود کنید",
    9000032: "بازگشت به خانه",

    //合约交易积分
    9100001: 'ذخیره امتیاز',
    9100002: 'ایردراپ را دریافت کنید',
    9100003: 'بازخرید جوایز',
    9100004: 'موجودی امتیاز',
    9100005: 'جزئیات',
    9100006: 'امتیازهای ورود',
    9100007: 'امتیاز معاملاتی',
    9100008: 'امتیازهای دعوت',
    9100009: 'امتیازهای پاداش',
    9100010: 'قرعه کشی',
    9100011: 'امتیاز بگیرید',
    9100012: 'قوانین امتیازدهی',
    9100013: 'جزئیات امتیازات',
    9100014: 'برای شرکت در این رویداد باید ثبت نام کنید. برای ثبت نام کلیک کنید',
    9100015: 'برای {day} روز متوالی معامله کرده اند و {num} امتیاز کسب کرده اند',
    9100016: 'امروز {num} امتیاز کسب کرد',
    9100017: 'استخر جایزه امتیاز',
    9100018: 'هر قرعه کشی خوش شانس {point} امتیاز مصرف می کند و حداکثر {num} بار قرعه کشی در روز می تواند قرعه کشی شود.',
    9100019: 'تعداد قرعه کشی های خوش شانس امروز',
    9100020: 'کاربر',
    9100021: 'امتیازها',
    9100022: 'موجودی امتیاز کافی نیست',
    9100023: 'موجودی امتیاز کافی نیست. لطفا قبل از شرکت در قرعه کشی امتیاز بگیرید.',
    9100024: 'تعداد قرعه کشی های خوش شانس به حد خود رسیده است!',
    9100025: 'تعداد قرعه کشی های خوش شانس امروز به حداکثر خود رسیده است. فردا دوباره امتحان کن.',
    9100026: 'نحوه کسب امتیاز',
    9100027: 'با مشارکت در فعالیت‌های جمع‌آوری امتیاز معامله قرارداد، امتیاز جمع کنید.',
    9100028: 'ثبت نام موفق',
    9100029: 'شما برای شرکت در فعالیت معاملات فیوچرز برای کسب امتیاز ثبت نام کرده اید. برای کسب امتیاز بیشتر بروید و تجارت کنید (دیگر از کمیسیون و پاداش های برگشت نقدی لذت نخواهید برد)',
    9100030: 'پس از لغو ثبت نام، دیگر امتیازی دریافت نخواهید کرد. آیا مطمئن هستید که می خواهید ثبت نام خود را لغو کنید؟',
    9100031: 'مرکز فعالیت امتیاز معاملاتی',
    9100032: 'امتیاز بگیرید',
    9100033: 'برای شرکت در این رویداد باید ثبت نام کنید. برای ثبت نام کلیک کنید',
    9100034: 'شما می توانید با معاملات مداوم معاملات فیوچرز امتیاز کسب کنید',
    9100035: 'کاربران می توانند برای تمام معاملات فیوچرز امتیاز کسب کنند',
    9100036: 'جدول امتیازات',
    9100037: 'پنج کاربر برتر در رتبه بندی معاملات روزانه امتیاز اضافی دریافت خواهند کرد',
    9100038: 'کاربران دعوت شده امتیاز دریافت می کنند و دعوت کننده می تواند امتیاز جایزه دریافت کند.',
    9100039: '{guy} از قبل کسب کرده اید<span style="color:#D9A31A"> {num} امتیاز!</span>',
    9100040: 'قرعه کشی خوش شانسی را امتحان کنید!',
    9100041: 'تبریک بابت گرفتن',
    9100042: 'همه انواع',
    9100043: 'در این صفحه بمانید',
    9100044: 'برای شرکت ثبت نام کنید',
    9100045: 'معاملات را ادامه دهید',
    9100046: 'در حال حاضر هیچ رویداد در حال انجام نیست. لطفا منتظر بروزرسانی‌ها باشید...',
    9100047: 'را با توکن های SCS مبادله کنید',
    9100048: '',
    9100049: '',

    9100050: 'تاریخ ها',
    9100051: 'تاریخ شروع را انتخاب کنید',
    9100052: 'تاریخ پایان',
    9100053: 'به',
    9100054: 'نوع',

    9100055: 'امتیازات کسب شده = حجم معاملات * 1٪ (مشکل با افزایش حجم کل معاملات پلت فرم بیشتر تنظیم می شود)',
    9100056: 'به عنوان مثال: کاربر از موقعیتی با حاشیه 100 USDT*100X=10000 USDT استفاده می کند.',
    9100057: 'سپس برای دریافت 100 امتیاز فقط به یک واریز 100 USDT نیاز داری',
    9100058: 'امتیاز معاملات تنها راه برای به دست آوردن توکن پلتفرم SCS است',
    9100059: 'امتیاز پاداش اضافی = کل امتیازات برای روز * نسبت پاداش رتبه بندی',
    9100060: 'رتبه بندی',
    9100061: 'مقام اول',
    9100062: 'مقام دوم',
    9100063: 'مقام سوم',
    9100064: 'مقام چهارم',
    9100065: 'مقام پنجم',
    9100066: 'کاربران دعوت شده امتیاز دریافت می کنند و دعوت کننده می تواند امتیاز جایزه دریافت کند.',
    9100067: 'فاکتور سطح',
    9100068: 'فرمول محاسبه: امتیاز ارجاع به دست آمده = امتیاز کسب شده توسط مدعو * ضریب سطح',
    9100069: 'ضریب سطح با توجه به وضعیت واقعی تنظیم می شود',
    9100070: 'به عنوان مثال: کاربر B در یک فعالیت امتیاز شرکت می کند و دعوت کننده آن کاربر A است و تعداد دعوت از کاربر A به سطح 3 رسیده است. کاربر B امتیاز جمع آوری کرده است = 360000;',
    9100071: 'سپس امتیازهای تبلیغاتی تجمعی که کاربر A می تواند کسب کند = 360000 * 30% = 108000',
    9100072: 'ضریب پاداش',
    9100073: '1 کاربران معاملاتی',
    9100074: 'حجم معاملات به 5 میلیون رسید',
    9100075: 'حجم معاملات به 20 میلیون رسید',

    9100076: 'انتقال',

    //热币
    9100080: 'به پایان رسید',
    9100081: 'برای برنده شدن جوایز روی «اکنون بپیوندید» کلیک کنید',
    9100082: 'مشاهده قوانین',
    9100083: 'همین الان ملحق شوید، همین الان بپیوندید',
    9100084: 'فعالیت',
    9100088: 'تجارت',
    9100089: 'سپرده',
    9100090: 'شما قبلا ثبت نام کرده اید.',

    9100091: 'این رویداد به پایان رسیده است، لطفا منتظر رویداد بعدی باشید!',
    9100092: 'رویداد هنوز شروع نشده است، لطفاً منتظر بمانید.',
    9100093: '',
    9100094: '',

    //自由区二维码分享页面
    9100095: 'لیست در اسپات Meme، در حال حاضر با آزادی مالی راه اندازی میشود',
    9100096: 'برنامه را باز کنید',
    9100097: '',
    9100098: '',
}
export default fa



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/fa.js